const LINKS = [
  { href: '#walk', label: 'Console' },
  { href: '#tableord', label: 'QR Ordering' },
  { href: '#mobile', label: 'Guest App' },
  { href: '#features', label: 'Features' },
  { href: '#how', label: 'How it works' },
  { href: '#ai', label: 'Intelligence' },
  { href: '#car-ordering', label: 'Car / Counter' },
  { href: '#hotel', label: 'Hospitality' },
];

export default function Nav() {
  return (
    <header className="nav">
      <a href="#top" className="nav-brand" aria-label="Plateera home">
        <img src="assets/logo.svg" alt="Plateera logo" width="32" height="32" />
        {/* <span className="brand-mark">
          <span />
        </span> */}
        <span className="brand-word">PLATEERA</span>
      </a>
      <nav className="nav-links">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href}>
            {l.label}
          </a>
        ))}
      </nav>
      <a href="#cta" className="nav-cta">
        <span>Request access</span>
        <svg viewBox="0 0 12 12" width="12" height="12">
          <path
            d="M2 6h8M6 2l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </header>
  );
}
